import React from 'react';
import { Line, Bar, Doughnut, Pie } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';

// Register ChartJS components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend
);

const Chart = ({ type = 'line', data, options = {}, height = '300px', title }) => {
  const defaultOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom',
        labels: {
          boxWidth: 12,
          padding: 15,
        }
      },
      title: {
        display: !!title,
        text: title,
        font: {
          size: 14,
          weight: 'bold'
        }
      }
    }
  };

  // Merge default options with provided options
  const chartOptions = {
    ...defaultOptions,
    ...options,
    plugins: {
      ...defaultOptions.plugins,
      ...(options.plugins || {})
    }
  };

  // Add scales for bar and line charts
  if (type === 'bar' || type === 'line') {
    chartOptions.scales = {
      x: {
        ticks: {
          maxRotation: 45,
          minRotation: 45,
          autoSkip: true,
          maxTicksLimit: 8,
        }
      },
      ...(options.scales || {})
    };
  }

  const ChartComponent = {
    line: Line,
    bar: Bar,
    doughnut: Doughnut,
    pie: Pie
  }[type] || Line;

  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-4">
      {title && (
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-3">
          {title}
        </h3>
      )}
      <div className="chart-container" style={{ height }}>
        <ChartComponent data={data} options={chartOptions} />
      </div>
    </div>
  );
};

export default Chart; 